// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Верховна Рада» (Verkhovna Rada, ключ `mandate`, група `committees`). */
export const verkhovnaRadaManifest: IModuleManifest = {
  key: 'mandate',
  group: 'committees',
  slug: 'verkhovna-rada',
  prefix: 'MND',
  name: { en: 'Verkhovna Rada', uk: 'Верховна Рада' },
  entities: [
    { key: 'mandate', slug: 'mandate', name: { en: 'Deputy mandates', uk: 'Депутатські мандати' }, main: true },
    { key: 'convocation', slug: 'convocation', name: { en: 'Convocations', uk: 'Скликання' }, main: false },
    { key: 'polparty', slug: 'polparty', name: { en: 'Political parties', uk: 'Політичні партії' }, main: false },
    { key: 'faction', slug: 'faction', name: { en: 'Factions and groups', uk: 'Фракції та групи' }, main: false },
    { key: 'assistant', slug: 'assistant', name: { en: 'Assistants', uk: 'Помічники' }, main: false },
  ],
  loadState: () => import('./state/verkhovnaRadaSlice').then((m) => m.verkhovnaRadaSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
  loadViews: () => import('./views').then((m) => m.views),
};
